<template>

 <div class="wrapper">
    <CRow class="mt-3">
      
      <CCol sm="12">
        <CCard>
          <CCardHeader><b> Event Description </b> </CCardHeader>
          <CCardBody>
            <CRow class="mt-3">
              <CCol sm="12">
              <c-textarea v-model="form.description" rows="5" class="mb-3" />
              </CCol>
            </CRow>    
          </CCardBody>  
        </CCard>
        <CButton block type="submit" v-on:click.prevent="update(form.id)"   color="info">Update</CButton>
      </CCol>


    </CRow>



        <!-- <pre>{{ $data | json }}</pre> -->
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
    <modalphotobanner></modalphotobanner>
    
  </div>
</template>

<script>
import datetime from 'vuejs-datetimepicker';
import event from '@/services/event';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

import setting from '@/services/setting';

import modalphotobg from './event_modal_photo_bgimage.vue';
import modalphotobanner from './event_modal_photo_bannerimage.vue';

export default {
  name: 'Dashboard',
  components: {
    alertmodal,datetime,modalphotobg,modalphotobanner
  },
  data () {
    return {
      btn_create: 0,
      btn_update: 0,
      

     form:{
        id: '',
        category:'',
        name:'',
        description:'',
        available:'',
        datetime_event:'',
        datetime_publish:'',
        location:'',
        link:'',
        file:'',
        file_banner:'',
        admission_fee:'',
        force_date:'',
        form_field: [
            {label: ""},
        ],
        custom_tickets: [
            {name: "", description: "", price: "",max: "",quota: ""},
        ],
        payment_information: "",
    },
    bgimage:'',
    bannerimage:'',
    temp_data: '',

    temp_index_ticket: 0,
    temp_index_field: 0,

      option_payment_selected:[],
      options_payment_temp:[],
      options_payment:[],


          options_available:[
            { text: 'Private ', value: 'a' },
            { text: 'iCare Coach', value: 'b' },
            { text: 'ICL and Core Team ', value: 'c' },
            { text: 'Head of Department', value: 'd' },
            { text: 'All Volunteers and Covenants ', value: 'e' },
            { text: 'Youth', value: 'f' },
            { text: 'Everyone ', value: 'g' },
          ],
          
    }
  
  },

  mounted(){
    this.loadData()
          EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
  },

  created () {
    
  },

  methods: {
    loadData(){
        this.temp_index_field = this.temp_index_field - 1;
        this.form.form_field.splice(0, 1);
        this.temp_index_ticket = this.temp_index_ticket - 1;
        this.form.custom_tickets.splice(0, 1);


      if(this.$route.query.id){
        this.btn_update = 1;
        // this.temp_index_field = this.temp_index_field - 1;
        // this.form.form_field.splice(0, 1);
        // this.temp_index_ticket = this.temp_index_ticket - 1;
        // this.form.custom_tickets.splice(0, 1);

        event.getEventbyID(this.$route.query.id)
        .then(res => {
          this.form.id = res.data.id;
          this.form.name = res.data.name;
          this.form.description = res.data.description;
          this.form.datetime_event = res.data.datetime_event;
          this.form.datetime_publish = res.data.datetime_publish;
          this.form.force_date = res.data.force_date;
          this.form.location = res.data.location;
          this.form.link = res.data.link;
          this.bgimage = res.data.bgimage;
          this.bannerimage = res.data.bannerimage;

          this.form.category = res.data.category;
          this.form.available = res.data.available;
          //this.form.form_field = res.data.form_field;

          this.temp_data = JSON.parse(res.data.form_field);
          for (let i=0; i <= this.temp_data.length-1; i++){
            //alert
            this.form.form_field.push({label: this.temp_data[i].label})
            console.log('test');
          }

          this.form.admission_fee = res.data.admission_fee;
          
          this.temp_data = JSON.parse(res.data.payment_information);
          for (let i=0; i <= this.temp_data.length-1; i++){
            //alert
            this.option_payment_selected.push({
              bank: this.temp_data[i].bank,
              account: this.temp_data[i].account,
              description: this.temp_data[i].description,
            })
            console.log('test');
          }

          for (let i=0; i <= res.data.event_tickets.length-1; i++){
            //alert
            this.form.custom_tickets.push({
              name: res.data.event_tickets[i].name,
              description: res.data.event_tickets[i].description,
              price: res.data.event_tickets[i].price,
              max: res.data.event_tickets[i].max,
              quota: res.data.event_tickets[i].quota,
            })
            console.log('test');
          }

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        this.btn_create = 1;
      }

      setting.getSetting("paymentmethod")
      .then(res => {
        this.options_payment_temp = JSON.parse(res.data.value);
        for (let i=0; i <= this.options_payment_temp.length-1; i++){
          this.options_payment.push({text: this.options_payment_temp[i].bank + " " + this.options_payment_temp[i].account, value: this.options_payment_temp[i]})
        }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })  
    }, 
    addRowTicket: function (index) {
        try {
            this.temp_index_ticket = this.temp_index_ticket + 1;
            this.form.custom_tickets.splice(index + 1, 0, {});
        } catch(e)
        {
            console.log(e);
        }
    },
    removeRowTicket: function (index) {
        this.temp_index_ticket = this.temp_index_ticket - 1;
        this.form.custom_tickets.splice(index, 1);
    },

    addRowField: function (index) {
        try {
          this.temp_index_field = this.temp_index_field + 1;
          this.form.form_field.splice(index + 1, 0, {});
        } catch(e)
        {
            console.log(e);
        }
    },
    removeRowField: function (index) {
      this.temp_index_field = this.temp_index_field - 1;
      this.form.form_field.splice(index, 1);
    },

    create(){
        this.form.payment_information = this.option_payment_selected

        let formData = new FormData();
        formData.append('category', this.form.category);
        formData.append('name', this.form.name);
        formData.append('description', this.form.description);
        formData.append('available', this.form.available);
        formData.append('datetime_event', this.form.datetime_event);
        formData.append('datetime_publish', this.form.datetime_publish);
        formData.append('location', this.form.location);
        formData.append('link', this.form.link);
        formData.append('file', this.form.file);
        formData.append('file_banner', this.form.file_banner);
        formData.append('admission_fee', this.form.admission_fee);
        formData.append('force_date', this.form.force_date);
        formData.append('form_field', JSON.stringify(this.form.form_field));
        formData.append('custom_tickets', JSON.stringify(this.form.custom_tickets));
        formData.append('payment_information', JSON.stringify(this.form.payment_information));

        event.createEvent(formData)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },

    update(id){
        this.form.payment_information = this.option_payment_selected
        event.updateEventDescription(id,this.form)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BGIMAGE', params)
        console.log('load modal photo')      
    },
    openModalPhotoBannerImage(id){
        var params = {title: 'Update Banner Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BANNERIMAGE', params)
        console.log('load modal photo')      
    },
  
  }
}
</script>
